export const daysOfTheWeek = {
  SUNDAY: { value: 'SUNDAY', label: 'Sunday' },
  MONDAY: { value: 'MONDAY', label: 'Monday' },
  TUESDAY: { value: 'TUESDAY', label: 'Tuesday' },
  WEDNESDAY: { value: 'WEDNESDAY', label: 'Wednesday' },
  THURSDAY: { value: 'THURSDAY', label: 'Thursday' },
  FRIDAY: { value: 'FRIDAY', label: 'Friday' },
  SATURDAY: { value: 'SATURDAY', label: 'Saturday' },
};
